const dataSpinnerStyles: string = 'data-spinner-styles';
const spinnerBackdropId: string = 'spinnerBackdrop';

function createBackdrop(): HTMLDivElement {
    const backdrop: HTMLDivElement = document.createElement(
        'div'
    ) as HTMLDivElement;
    backdrop.id = spinnerBackdropId;
    backdrop.classList.add('backdrop');

    return backdrop;
}

function createSpinnerElement(): HTMLSpanElement {
    const spinnerElementClassList: Array<string> = new Array<string>(
        'fa',
        'fa-loader',
        'fa-regular',
        'fa-spin',
        'align-self-center'
    );
    const spinnerElement: HTMLSpanElement = document.createElement(
        'span'
    ) as HTMLSpanElement;
    spinnerElement.classList.add(...spinnerElementClassList);
    return spinnerElement;
}

export function addFullPageSpinner(
    showBackdrop: boolean,
    elementId: string
): void {
    const element: HTMLElement | null =
        (document.getElementById(elementId) as HTMLElement) ?? null;
    const backdrop: HTMLDivElement = createBackdrop();

    if (showBackdrop) {
        // prevent scroll when backdrop is shown
        // (element ?? document.body).style.overflow = 'hidden';
        backdrop.classList.add('-visible');
    }

    backdrop.appendChild(createSpinnerElement());
    (element ?? document.body).appendChild(backdrop);
}

export function removeFullPageSpinner(elementId: string): void {
    const element: HTMLElement | null =
        (document.getElementById(elementId) as HTMLElement) ?? null;

    // remove scroll prevention
    (element ?? document.body).style.overflow = 'unset';

    const backdrop: HTMLElement | null =
        (document.getElementById(spinnerBackdropId) as HTMLElement) ?? null;
    // remove the backdrop if it exists
    backdrop?.remove();
}

export function addSpinner(elementId: string): HTMLElement | null {
    const element: HTMLElement | null =
        (document.getElementById(elementId) as HTMLElement) ?? null;
    const backdrop: HTMLDivElement = createBackdrop();

    backdrop.appendChild(createSpinnerElement());

    if (Boolean(element)) {
        // Store original styles
        element.setAttribute(
            dataSpinnerStyles,
            JSON.stringify({
                height: element.style.height,
                position: element.style.position
            })
        );
        // Update styles
        element.style.height = '100%';
        element.style.position = 'relative';

        // Hide all children
        for (let i: number = 0; i < element.children.length; i++) {
            element.children.item(i)?.setAttribute('hidden', String(true));
        }

        element.appendChild(backdrop);
    }

    return element;
}

export function removeSpinner(elementId: string) {
    const element: HTMLElement | null =
        (document.getElementById(elementId) as HTMLElement) ?? null;

    if (Boolean(element)) {
        const spinnerStyles = JSON.parse(
            element?.getAttribute(dataSpinnerStyles) ?? '{}'
        );

        // Restore original styles
        element.style.height = spinnerStyles.height;
        element.style.position = spinnerStyles.position;

        // Remove data attribute
        element.removeAttribute(dataSpinnerStyles);

        // Restore all children
        for (let i: number = 0; i < element.children.length; i++) {
            element.children.item(i)?.removeAttribute('hidden');
        }
    }

    const backdrop: HTMLElement | null =
        (document.getElementById(spinnerBackdropId) as HTMLElement) ?? null;
    backdrop?.remove();
}

// "export" through the window global object for JavaScript compatibility
Object.assign(window, {
    addSpinner,
    removeSpinner,
    addFullPageSpinner,
    removeFullPageSpinner
});
